// extracted by mini-css-extract-plugin
module.exports = {"container":"Targets_container__3ECIj","targetContainer":"Targets_targetContainer__3LGUB","icon":"Targets_icon__21GnK"};